import gql from 'graphql-tag';

export const getLivesbyCourseId = gql`
  query faculCourse($courseId: ID!, $todayDate: DateTime!) {
    faculCourse(where: { id: $courseId }) {
      faculLiveVideo(where: { transmissionEndDate_gte: $todayDate }) {
        id
        name
        slug
        type
        thumbnailUrl
        kalturaId
        youtubeId
        livestreamUrl
        zoomId
        transmissionStartDate
        transmissionEndDate
      }
    }
  }
`;

export const getCoursesByIdList = gql`
  query faculCourses($coursesIds: [ID!]!) {
    faculCourses(where: { id_in: $coursesIds }, stage: PUBLISHED) {
      id
      name
      slug
      dexCourseId
    }
  }
`;

export const getMicrocertificateBySubmouleIdList = gql`
  query faculMicrocertificates($submoduleIds: [ID!]!) {
    faculMicrocertificates(where: { faculModule: { id_in: $submoduleIds } }, stage: PUBLISHED) {
      name
      id
      faculModule {
        id
      }
    }
  }
`;

export const getSubmodulesByIdList = gql`
  query faculModules($submoduleIds: [ID!]!) {
    faculModules(where: { id_in: $submoduleIds }, stage: PUBLISHED) {
      name
      id
      description
    }
  }
`;

export const getDisciplineLives = gql`
  query faculDisciplinesLives($disciplineInstanceId: ID!) {
    faculDisciplineInstance(where: { id: $disciplineInstanceId }) {
      faculLiveVideo {
        id
        name
        slug
        type
        thumbnailUrl
        kalturaId
        youtubeId
        livestreamUrl
        zoomId
        transmissionStartDate
        transmissionEndDate
      }
    }
  }
`;

export const getDisciplineLivesForHome = gql`
  query faculDisciplinesLives($disciplineInstanceIds: [ID!]!, $todayDate: DateTime) {
    faculDisciplineInstances(where: { id_in: $disciplineInstanceIds }) {
      id
      slug
      faculLiveVideo(where: { transmissionEndDate_gte: $todayDate }) {
        id
        name
        slug
        type
        thumbnailUrl
        kalturaId
        youtubeId
        livestreamUrl
        zoomId
        transmissionStartDate
        transmissionEndDate
      }
      faculDiscipline {
        id
        slug
      }
    }
  }
`;

export const getLessonBySlug = gql`
  query getLessonBySlug($slug: String!) {
    faculLesson(where: { slug: $slug }) {
      id
      name
      description
      slug
      type
      items: contents {
        typename: __typename
        ... on FaculArticle {
          id
          title
          dexArticleId
        }
        ... on FaculExercise {
          id
          name
          dexExerciseId
          exerciseType: type
        }
        ... on FaculVideo {
          id
          slug
          actualDurationInSeconds
          videoName: name
          youtubeId
          kalturaId
        }
      }
      updatedAt
    }
  }
`;

export const getDisciplineInstance = gql`
  query faculDisciplineInstanceBySlug($disciplineSlug: String!) {
    faculDisciplineInstance(where: { slug: $disciplineSlug }) {
      id
      slug
      name

      faculDiscipline {
        id
        name
        description
        type
      }

      lessons: faculLessons {
        id
        name
        type
        slug
        description
        updatedAt
        items: contents {
          typename: __typename
          ... on FaculArticle {
            id
            title
            dexArticleId
          }
          ... on FaculExercise {
            id
            name
            exerciseType: type
            dexExerciseId
          }
          ... on FaculVideo {
            id
            videoName: name
            kalturaId
            youtubeId
            slug
            actualDurationInSeconds
          }
        }
      }

      reviewLists: faculReviewLists {
        dexReviewListId
      }
    }
  }
`;
